// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/list_my_vision_projects.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionProjectListItem } from "./vision_project_pb";
import { file_vision_projects_v1_vision_project } from "./vision_project_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/list_my_vision_projects.proto.
 */
export const file_vision_projects_v1_list_my_vision_projects: GenFile = /*@__PURE__*/
  fileDesc("CjB2aXNpb24vcHJvamVjdHMvdjEvbGlzdF9teV92aXNpb25fcHJvamVjdHMucHJvdG8SGXByb3Rvcy52aXNpb24ucHJvamVjdHMudjEinQMKG0xpc3RNeVZpc2lvblByb2plY3RzUmVxdWVzdBJNCgZwYXJhbXMYASABKAsyPS5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLkxpc3RNeVZpc2lvblByb2plY3RzUmVxdWVzdC5QYXJhbXMSVQoKcGFnaW5hdGlvbhgCIAEoCzJBLnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuTGlzdE15VmlzaW9uUHJvamVjdHNSZXF1ZXN0LlBhZ2luYXRpb24akgEKBlBhcmFtcxIiChppbmNsdWRlX2xvY2F0aW9uX3N1bW1hcmllcxgBIAEoCBIfChdpbmNsdWRlX2NvdmVyX3RodW1ibmFpbBgCIAEoCBIhChlpbmNsdWRlX3RvdGFsX2ltYWdlX2NvdW50GAMgASgIEiAKGGluY2x1ZGVfZ2VuZXJhdGlvbl9jb3VudBgEIAEoCBpDCgpQYWdpbmF0aW9uEhEKCXBhZ2Vfc2l6ZRgBIAEoBRIUCgpuZXh0X3Rva2VuGAIgASgJSABCDAoKcGFnZV90b2tlbiK4AgocTGlzdE15VmlzaW9uUHJvamVjdHNSZXNwb25zZRJOCgZyZXN1bHQYASABKAsyPi5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLkxpc3RNeVZpc2lvblByb2plY3RzUmVzcG9uc2UuUmVzdWx0ElYKCnBhZ2luYXRpb24YAiABKAsyQi5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLkxpc3RNeVZpc2lvblByb2plY3RzUmVzcG9uc2UuUGFnaW5hdGlvbhpJCgZSZXN1bHQSPwoFaXRlbXMYASADKAsyMC5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLlZpc2lvblByb2plY3RMaXN0SXRlbRolCgpQYWdpbmF0aW9uEhcKD25leHRfcGFnZV90b2tlbhgBIAEoCWIGcHJvdG8z", [file_vision_projects_v1_vision_project]);

/**
 * @generated from message protos.vision.projects.v1.ListMyVisionProjectsRequest
 */
export type ListMyVisionProjectsRequest = Message<"protos.vision.projects.v1.ListMyVisionProjectsRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.ListMyVisionProjectsRequest.Params params = 1;
   */
  params?: ListMyVisionProjectsRequest_Params | undefined;

  /**
   * @generated from field: protos.vision.projects.v1.ListMyVisionProjectsRequest.Pagination pagination = 2;
   */
  pagination?: ListMyVisionProjectsRequest_Pagination | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.ListMyVisionProjectsRequest.
 * Use `create(ListMyVisionProjectsRequestSchema)` to create a new message.
 */
export const ListMyVisionProjectsRequestSchema: GenMessage<ListMyVisionProjectsRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_my_vision_projects, 0);

/**
 * @generated from message protos.vision.projects.v1.ListMyVisionProjectsRequest.Params
 */
export type ListMyVisionProjectsRequest_Params = Message<"protos.vision.projects.v1.ListMyVisionProjectsRequest.Params"> & {
  /**
   * @generated from field: bool include_location_summaries = 1;
   */
  includeLocationSummaries: boolean;

  /**
   * @generated from field: bool include_cover_thumbnail = 2;
   */
  includeCoverThumbnail: boolean;

  /**
   * @generated from field: bool include_total_image_count = 3;
   */
  includeTotalImageCount: boolean;

  /**
   * @generated from field: bool include_generation_count = 4;
   */
  includeGenerationCount: boolean;
};

/**
 * Describes the message protos.vision.projects.v1.ListMyVisionProjectsRequest.Params.
 * Use `create(ListMyVisionProjectsRequest_ParamsSchema)` to create a new message.
 */
export const ListMyVisionProjectsRequest_ParamsSchema: GenMessage<ListMyVisionProjectsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_my_vision_projects, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.ListMyVisionProjectsRequest.Pagination
 */
export type ListMyVisionProjectsRequest_Pagination = Message<"protos.vision.projects.v1.ListMyVisionProjectsRequest.Pagination"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from oneof protos.vision.projects.v1.ListMyVisionProjectsRequest.Pagination.page_token
   */
  pageToken: {
    /**
     * @generated from field: string next_token = 2;
     */
    value: string;
    case: "nextToken";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.projects.v1.ListMyVisionProjectsRequest.Pagination.
 * Use `create(ListMyVisionProjectsRequest_PaginationSchema)` to create a new message.
 */
export const ListMyVisionProjectsRequest_PaginationSchema: GenMessage<ListMyVisionProjectsRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_my_vision_projects, 0, 1);

/**
 * @generated from message protos.vision.projects.v1.ListMyVisionProjectsResponse
 */
export type ListMyVisionProjectsResponse = Message<"protos.vision.projects.v1.ListMyVisionProjectsResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.ListMyVisionProjectsResponse.Result result = 1;
   */
  result?: ListMyVisionProjectsResponse_Result | undefined;

  /**
   * @generated from field: protos.vision.projects.v1.ListMyVisionProjectsResponse.Pagination pagination = 2;
   */
  pagination?: ListMyVisionProjectsResponse_Pagination | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.ListMyVisionProjectsResponse.
 * Use `create(ListMyVisionProjectsResponseSchema)` to create a new message.
 */
export const ListMyVisionProjectsResponseSchema: GenMessage<ListMyVisionProjectsResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_my_vision_projects, 1);

/**
 * @generated from message protos.vision.projects.v1.ListMyVisionProjectsResponse.Result
 */
export type ListMyVisionProjectsResponse_Result = Message<"protos.vision.projects.v1.ListMyVisionProjectsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.projects.v1.VisionProjectListItem items = 1;
   */
  items: VisionProjectListItem[];
};

/**
 * Describes the message protos.vision.projects.v1.ListMyVisionProjectsResponse.Result.
 * Use `create(ListMyVisionProjectsResponse_ResultSchema)` to create a new message.
 */
export const ListMyVisionProjectsResponse_ResultSchema: GenMessage<ListMyVisionProjectsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_my_vision_projects, 1, 0);

/**
 * @generated from message protos.vision.projects.v1.ListMyVisionProjectsResponse.Pagination
 */
export type ListMyVisionProjectsResponse_Pagination = Message<"protos.vision.projects.v1.ListMyVisionProjectsResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.vision.projects.v1.ListMyVisionProjectsResponse.Pagination.
 * Use `create(ListMyVisionProjectsResponse_PaginationSchema)` to create a new message.
 */
export const ListMyVisionProjectsResponse_PaginationSchema: GenMessage<ListMyVisionProjectsResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_list_my_vision_projects, 1, 1);

